export const Excel = 0;
export const Edi = 1;
export const Xml = 2;